import { render, staticRenderFns } from "./NewServiceCreate.vue?vue&type=template&id=a2fae19c&scoped=true"
import script from "./NewServiceCreate.vue?vue&type=script&lang=js"
export * from "./NewServiceCreate.vue?vue&type=script&lang=js"
import style0 from "./NewServiceCreate.vue?vue&type=style&index=0&id=a2fae19c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fae19c",
  null
  
)

export default component.exports